import React from "react";
import "../Styles/GridView.scss";

import { transform } from "framer-motion";
import GridCard from "./GridCard";



const GridView = ({ testSolutions, trackerId }) => {
  return (
    <>
      <div className="GridViewWrapper">
        {testSolutions?.map((data, idx) => {
          return <GridCard data={data} index={idx} trackerId={trackerId} />;
        })}
      </div>
    </>
  );
};

export default GridView;
